import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import { Link } from 'react-router-dom';

// import imgSeparator from "../assets/img/whp-separator.png";
import btnPlay from "../assets/img/whp-btn-play.svg"

import BackgroundVideo from './animated/whp-background-video';
import videoBG from '../assets/video/whp-bg-dancing.m4v';

import logoDancingWashers from '../assets/img/whp-logo-dancingwashers.svg';
const TurnOnSection = ({ togglePlay }) => {
    const props = useSpring({
        opacity: 1,
        transform: `translateY(0%)`,
        from: { opacity: 0, transform: `translateY(100%)` },
    });

    return (
        <>
            <animated.div id="introSection" className="sectionItem d-flex align-items-center tourn-on" style={{ ...props }}>
                <BackgroundVideo videoData={videoBG} />

                <div className='container'>
                    <div className='row'>
                        <div className='col-10 offset-1 text-center position-relative zIndex-1'>
                            {/* <img src={imgSeparator} className="d-block m-auto mb-4 separator" alt="Separador" /> */}
                            <h2 className="text-center"><strong>Sube</strong> el volumen</h2>
                            <p>Entre más baile tu lavadora, más beneficios podrías obtener.</p>
                            <div className='col-10 offset-1 col-md-8 offset-md-2'>
                                <img src={logoDancingWashers} alt='Logo Dancing Washers' className='w-75' />
                            </div>
                            <Link className='btn btn-primary' to="/upload">
                                Continuar
                            </Link>
                        </div>
                    </div>
                </div>
            </animated.div>
            {/* <label className="switch" >
                <input type="checkbox" onClick={togglePlay} />
                <span className="slider round"></span>
            </label> */}
        </>
    );
};

export default TurnOnSection;